import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumChangeType implements BaseEnumType {
  private static allValues: EnumChangeType[] = []; // make sure this is top-most
  
  public static fix = new EnumChangeType(1, "Fix", "enum_change_type_fix");
  public static enhancement = new EnumChangeType(2, "Enhancement", "enum_change_type_enhancement");
  public static newVersion = new EnumChangeType(3, "NewVersion", "enum_change_type_new_version");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumChangeType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isFix() { return this === EnumChangeType.fix; }
  public isEnhancement() { return this === EnumChangeType.enhancement; }
  public isNewVersion() { return this === EnumChangeType.newVersion; }

  public static getValues(): readonly EnumChangeType[] {
    return EnumChangeType.allValues;
  }

  public static getValuesExcept0(): readonly EnumChangeType[] {
    return EnumChangeType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumChangeType {
    const found = EnumChangeType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumChangeType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumChangeType): EnumChangeType {
    const found = name ? EnumChangeType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumChangeType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumChangeType>): boolean {
    return this.key === other?.key;
  }
}